import { render, staticRenderFns } from "./myEmail2.vue?vue&type=template&id=7cdc28a1&scoped=true&"
import script from "./myEmail2.vue?vue&type=script&lang=js&"
export * from "./myEmail2.vue?vue&type=script&lang=js&"
import style0 from "./myEmail2.vue?vue&type=style&index=0&id=7cdc28a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc28a1",
  null
  
)

export default component.exports